import type { one_to_one } from '@fireworkhq/proto-contract'
import type { useStoreApi } from '@liveHelper/models/store'
import { actionsSelector } from '@liveHelper/models/store'
import type { ChatChannelConfig } from '@oneToOne/shared/services/rest/types'

/** Handles the visitor channel join error response. */
export function handleJoinErrorReply({
  response,
  storeApi,
  chatChannelConfig,
}: {
  response: one_to_one.visitor.ChannelJoinErrorResponse
  storeApi: ReturnType<typeof useStoreApi>
  chatChannelConfig: ChatChannelConfig | undefined
}) {
  if (response?.reason === 'REASON_NO_AGENTS_AVAILABLE') {
    actionsSelector(storeApi.getState()).setWidgetState({
      isWidgetVisible: chatChannelConfig?.feature_flags?.ava ? true : false, // TODO !!chatChannelConfig?.config.scheduling_url,
      waitlistCapacityReached: false,
      visibilityRulesMatch: false, // TODO https://fwn.atlassian.net/browse/OTO-1926
    })
  }
}
